import { createBrowserRouter, Navigate } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { ComprobanteList } from './pages/Comprobantes/ComprobanteList';
import { ComprobanteForm } from './pages/Comprobantes/ComprobanteForm';
import { ProductList } from './pages/Products/ProductList';
import { ProductForm } from './pages/Products/ProductForm';
import { ProductDetail } from './pages/Products/ProductDetail';
import { CategoryList } from './pages/Categories/CategoryList';
import { ClientList } from './pages/Clients/ClientList';
import { ClientForm } from './pages/Clients/ClientForm';
import { SupplierList } from './pages/Suppliers/SupplierList';
import { SupplierForm } from './pages/Suppliers/SupplierForm';
import { WholesaleList } from './pages/Wholesale/WholesaleList';
import { WholesaleForm } from './pages/Wholesale/WholesaleForm';
import { InstallmentList } from './pages/Installments/InstallmentList';
import { InstallmentForm } from './pages/Installments/InstallmentForm';
import { InstallmentDetail } from './pages/Installments/InstallmentDetail';
import { Promociones } from './pages/Promociones/Promociones';
import { InvoiceList } from './pages/Invoices/InvoiceList';
import { InvoiceForm } from './pages/Invoices/InvoiceForm';
import { ShippingList } from './pages/Shipping/ShippingList';
import { ShippingForm } from './pages/Shipping/ShippingForm';
import { ShippingDetail } from './pages/Shipping/ShippingDetail';
import { Reports } from './pages/Reports/Reports';
import { Settings } from './pages/Settings/Settings';
import { Social } from './pages/Social/Social';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Calendario from './pages/Calendario';
import SaleList from './pages/Sales';
import SaleForm from './pages/Sales/SaleForm';
import SaleDetail from './pages/Sales/SaleDetail';
import GastoList from './pages/Gastos';
import GastoForm from './pages/Gastos/GastoForm';
import GastoDetail from './pages/Gastos/GastoDetail';
import ComprobanteDetail from './pages/Comprobantes/ComprobanteDetail';
import { DevolucionList } from './pages/Devoluciones/DevolucionList';
import { DevolucionForm } from './pages/Devoluciones/DevolucionForm';
import { DevolucionDetail } from './pages/Devoluciones/DevolucionDetail';
import { CompraList } from './pages/Compras/CompraList';
import { CompraForm } from './pages/Compras/CompraForm';
import { CompraDetail } from './pages/Compras/CompraDetail';
import { EnvioList } from './pages/Envios/EnvioList';
import { EnvioForm } from './pages/Envios/EnvioForm';
import { EnvioDetail } from './pages/Envios/EnvioDetail';
import { EnvioLayout } from './components/layout/EnvioLayout';
import { MisEnviosRepartidor } from './pages/Envios/MisEnviosRepartidor';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <Login />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: '/envios-repartidor',
        element: <EnvioLayout />,
        children: [
          { index: true, element: <MisEnviosRepartidor /> },
        ],
      },
      {
        path: '/',
        element: <Layout />,
        children: [
          { index: true, element: <Navigate to="/dashboard" replace /> },
          { path: 'dashboard', element: <Dashboard /> },
          {
            path: 'productos',
            children: [
              { index: true, element: <ProductList /> },
              { path: 'nuevo', element: <ProductForm /> },
              { path: 'editar/:id', element: <ProductForm /> },
              { path: ':id', element: <ProductDetail /> },
            ],
          },
          {
            path: 'categorias',
            children: [
              { index: true, element: <CategoryList /> },
            ],
          },
          {
            path: 'clientes',
            children: [
              { index: true, element: <ClientList /> },
              { path: 'nuevo', element: <ClientForm /> },
              { path: 'editar/:id', element: <ClientForm /> },
            ],
          },
          {
            path: 'proveedores',
            children: [
              { index: true, element: <SupplierList /> },
              { path: 'nuevo', element: <SupplierForm /> },
              { path: 'editar/:id', element: <SupplierForm /> },
            ],
          },
          {
            path: 'compras',
            children: [
              { index: true, element: <CompraList /> },
              { path: 'nuevo', element: <CompraForm /> },
              { path: 'editar/:id', element: <CompraForm /> },
              { path: ':id', element: <CompraDetail /> },
            ],
          },
          {
            path: 'mayoristas',
            children: [
              { index: true, element: <WholesaleList /> },
              { path: 'nuevo', element: <WholesaleForm /> },
              { path: 'editar/:id', element: <WholesaleForm /> },
            ],
          },
          {
            path: 'cuotas',
            children: [
              { index: true, element: <InstallmentList /> },
              { path: 'nuevo', element: <InstallmentForm /> },
              { path: 'editar/:id', element: <InstallmentForm /> },
              { path: ':id', element: <InstallmentDetail /> },
            ],
          },
          {
            path: 'comprobantes',
            children: [
              { index: true, element: <ComprobanteList /> },
              { path: 'nuevo', element: <ComprobanteForm /> },
              { path: 'editar/:id', element: <ComprobanteForm /> },
              { path: ':id', element: <ComprobanteDetail /> },
            ],
          },
          {
            path: 'facturas',
            children: [
              { index: true, element: <InvoiceList /> },
              { path: 'nuevo', element: <InvoiceForm /> },
              { path: 'editar/:id', element: <InvoiceForm /> },
            ],
          },
          {
            path: 'ventas',
            children: [
              { index: true, element: <SaleList /> },
              { path: 'nuevo', element: <SaleForm /> },
              { path: 'editar/:id', element: <SaleForm /> },
              { path: ':id', element: <SaleDetail /> },
            ],
          },
          {
            path: 'gastos',
            children: [
              { index: true, element: <GastoList /> },
              { path: 'nuevo', element: <GastoForm /> },
              { path: 'editar/:id', element: <GastoForm /> },
              { path: ':id', element: <GastoDetail /> },
            ],
          },
          {
            path: 'remitos',
            children: [
              { index: true, element: <ShippingList /> },
              { path: 'nuevo', element: <ShippingForm /> },
              { path: 'editar/:id', element: <ShippingForm /> },
              { path: ':id', element: <ShippingDetail /> },
            ],
          },
          {
            path: 'envios',
            children: [
              { index: true, element: <EnvioList /> },
              { path: 'nuevo', element: <EnvioForm /> },
              { path: 'editar/:id', element: <EnvioForm /> },
              { path: ':id', element: <EnvioDetail /> },
            ],
          },
          {
            path: 'devoluciones',
            children: [
              { index: true, element: <DevolucionList /> },
              { path: 'nuevo', element: <DevolucionForm /> },
              { path: 'editar/:id', element: <DevolucionForm /> },
              { path: ':id', element: <DevolucionDetail /> },
            ],
          },
          {
            path: 'social',
            element: <Social />,
          },
          {
            path: 'promociones',
            element: <Promociones />,
          },
          {
            path: 'reportes',
            element: <Reports />,
          },
          {
            path: 'calendario',
            element: <Calendario />,
          },
          {
            path: 'configuracion',
            element: <Settings />,
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/login" replace />,
  },
]);